<template>
    <div>
        <v-card style="margin-bottom: 50px;">
            <v-card-text>
                <v-data-table
                    :items="items.all"
                    :headers="headers"
                    :items-per-page="-1"
                    class="striped"
                    :hide-default-footer="true"
                >
                    <template #top>
                        <HeaderPage
                            :items="items"
                            :loading="loading"
                            @handleEditAcu="handleEditAcu"
                        />
                    </template>
                    <template #[`header.DONE`]="{ header }">
                        {{ header.text }}
                        (<v-icon dense color="success">
                            {{ header.icon }}
                        </v-icon>)
                    </template>
                    <template #[`header.DONE_TIMESTAMP`]="{ header }">
                        {{ header.text }}
                        (<v-icon dense color="error">
                            {{ header.icon }}
                        </v-icon>)
                    </template>
                    <template #[`header.DONE_PIC`]="{ header }">
                        {{ header.text }}
                        (<v-icon dense>
                            {{ header.icon }}
                        </v-icon>)
                    </template>
                    <template #[`item.DONE_TIMESTAMP`]="{ item }">
                        {{ item.DONE_TIMESTAMP ? formatDate(item.DONE_TIMESTAMP) : '-' }}
                    </template>
                    <template #[`item.DONE_PIC`]="{ item }">
                        {{ item.DONE_PIC ? formatName(item.DONE_PIC) : '-' }}
                    </template>
                    <template #[`item.DONE`]="{ item }">
                        <v-icon :color="item.DONE === 'YES' ? 'green' : 'red'">
                            {{ item.DONE === "YES" ? mdiCheckboxMarked : mdiClose }}
                        </v-icon>
                    </template>
                    <template #[`item.DET`]="{ item }">
                        <ul v-if="isDetArray(item.DET)" style="list-style-type: none; padding-left: 0;">
                            <li v-for="(det, key) in item.DET.split(';')" :key="key">
                                {{ det }}
                            </li>
                        </ul>
                        <span v-else>{{ item.DET }}</span>
                    </template>
                </v-data-table>
            </v-card-text>
        </v-card>
        <v-dialog
            v-model="showDialog"
            width="600"
        >
            <v-card>
                <template #progress>
                    <v-progress-linear
                        color="teal darken-1"
                        height="5"
                        indeterminate
                    />
                </template>
                <v-form
                    ref="form"
                    @submit.prevent="submitForm"
                >
                    <v-card-title style="background-color: #009688; color: white;">
                        Confirm Completion
                    </v-card-title>
                    <v-card-text style="padding: 0; margin: 0">
                        <!-- You're about to mark these diagnostic procedures as done. -->
                        <div style="height: auto; max-height: 50vh; overflow-x: scroll; overflow-x: hidden;">
                            <div style="position: sticky; top: 0; padding: 1px 0 0 10px; background-color: #eee !important; opacity: 1 !important; z-index: 2;">
                                <v-checkbox
                                    v-model="selectAll"
                                    label="Select All"
                                    color="teal"
                                    :indeterminate="indeterminateData"
                                    style="margin-left: 3px;"
                                    @change="handleChangeSelectAll"
                                />
                            </div>
                            <v-checkbox
                                v-for="(item, index) in items.toEdit"
                                :key="index"
                                v-model="item.value"
                                :disabled="loading"
                                :label="item.DET"
                                color="teal"
                                style="border-bottom: 1px solid #ddd;"
                            >
                                <template #prepend>
                                    <span>&nbsp;</span>
                                </template>
                            </v-checkbox>
                        </div>
                    </v-card-text>
                    <v-card-actions>
                        <p style="padding: 0; margin: 0; font-size: 12px;">
                            Once saved, all actions cannot be undone.
                        </p>
                        <v-spacer />
                        <v-btn
                            :disabled="loading"
                            :style="{ width: '120px' }"
                            color="#333"
                            text
                            @click="showDialog = false"
                        >
                            cancel
                        </v-btn>
                        <v-btn
                            :disabled="loading"
                            :loading="loading"
                            :style="{ width: '120px', fontWeight: '500', letterSpacing: '3px' }"
                            type="submit"
                            class="white--text"
                            color="teal darken-1"
                        >
                            proceed
                        </v-btn>
                    </v-card-actions>
                </v-form>
            </v-card>
        </v-dialog>
    </div>
</template>

<script>
import { mdiAccount, mdiCalendarMonth, mdiCheck, mdiCheckboxMarked, mdiClose, mdiDoctor } from '@mdi/js'
import HeaderPage from './HeaderPage.vue'
import { moment } from '../../../../utils/date-shim'
import { mapActions, mapGetters } from 'vuex'

export default {
    components: {
        HeaderPage
    },
    props: ['patientData'],
    data: ()=>({
        mdiAccount, mdiCalendarMonth, mdiCheck, mdiCheckboxMarked, mdiClose, mdiDoctor,
        indeterminateData: false,
        selectAll: false,
        loading: false,
        showEdit: false,
        items: {
            all: [],
            toEdit: []
        },
        headers: [
            { text: 'ITEM', value: 'OID', icon: mdiAccount },
            { text: 'PROCEDURES', value: 'DET', icon: mdiAccount },
            { text: 'DONE', value: 'DONE', icon: mdiCheck },
            { text: 'TIMESTAMP', value: 'DONE_TIMESTAMP', icon: mdiCalendarMonth },
            { text: 'STAFF', value: 'DONE_PIC', icon: mdiDoctor }
        ]
    }),
    computed: {
        ...mapGetters(['markAcuProcDoneData', 'verifyAcuApprovalData']),
        isNoSelected() {
            return this.items.toEdit.every(item => item.value === false)
        },
        isAllSelected() {
            return this.items.toEdit.every(item => item.value === true)
        },
        isSomeSelectedComp() {
            return this.items.toEdit.some(item => item.value == true)
        },
        showDialog: {
            get() {
                return this.showEdit
            },
            set() {
                this.showEdit = false
            }
        }
    },
    watch: {
        isNoSelected(newVal) {
            if (newVal) {
                this.indeterminateData = false
                this.selectAll = false
            }
        },
        isAllSelected(newVal) {
            this.$nextTick(()=>{
                if (newVal) {
                    this.indeterminateData = false
                    this.selectAll = true
                } else {
                    if (this.isSomeSelectedComp) {
                        this.indeterminateData = true
                        this.selectAll = null
                    } else if (this.isNoSelected) {
                        this.indeterminateData = false
                        this.selectAll = false
                    }
                }
            })
        },
        isSomeSelectedComp(newVal) {
            if (newVal) {
                this.indeterminateData = true
            }
        },
        verifyAcuApprovalData(newVal) {
            if (newVal.status === 200) {
                this.items.all = structuredClone(newVal.data).map(item => ({ ...item, value: item.DONE === 'YES' }))
            }
            this.loading = false
        }
    },
    methods: {
        ...mapActions(['markAcuProcDone', 'verifyAcuApproval']),
        isDetArray(det) {
            if (det) {
                const detCount = det.split(';')
                return detCount.length > 1
            }
            return false
        },
        isSomeSelected() {
            if (this.isAllSelected) {
                return false
            } else {
                if (this.isSomeSelectedComp) {
                    return true
                } else if (this.isNoSelected) {
                    return false
                }
            }
        },
        handleChangeSelectAll(item) {
            this.items.toEdit.map(i => i.value = item)
        },
        formatName(name) {
            return name
                .toLowerCase()
                .replace(/\b\w/g, match => match.toUpperCase())
        },
        formatDate(date) {
            return moment(date).format('MMMM D, YYYY hh:mm:ss A')
        },
        async submitForm() {
            if (this.$refs && this.$refs.form.validate()) {
                if (this.isNoSelected) {
                    this.showDialog = false
                    return
                }
                this.loading = true
                const toEdit = this.items.toEdit.filter(item => item.value === true)

                const sleep = (ms) => new Promise(resolve => setTimeout(resolve, ms))

                for(let i=0; i<toEdit.length; i++) {
                    const paramsMarkAcuProcDone = {
                        MSUU_C: toEdit[i].MSUU_C,
                        OPAN_N: toEdit[i].OPAN_N,
                        MEMB_N: toEdit[i].MEMB_N,
                        OID_N: toEdit[i].OID
                    }
                    await this.markAcuProcDone(paramsMarkAcuProcDone)
                    await sleep(500)
                }
                const paramsVerifyAcuApproval = {
                    MSUU_C: toEdit[0].MSUU_C,
                    OPAN_N: toEdit[0].OPAN_N,
                    MEMB_N: toEdit[0].MEMB_N
                }
                this.verifyAcuApproval(paramsVerifyAcuApproval)
                this.showDialog = false
            }
        },
        handleEditAcu() {
            this.items.toEdit = structuredClone(this.items.all.filter(item => item.DONE === 'NO').map(item => ({ ...item, value: item.DONE === 'YES' })))
            this.showEdit = true
        }
    }
}
</script>

<style>
.striped tbody tr:nth-child(odd) {
    background-color: #eee;
}
</style>
